import * as uuid from 'uuid';

export const generateUUID = () => {
	return uuid.v4();
};
